import React from "react";
import { Skeleton } from "@mui/material";
import Grid from '@mui/material/Grid2';
import Container from "@mui/material/Container";

const OrgDashSkeleton = () => {

    return (
        <>
                <Grid container spacing={2} justify="center">
                    <Grid item size={{xs:12,md:8}}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            animation="wave"
                            height={720}
                            style={{borderRadius:16,marginBottom:10}}
                        />
                    </Grid>
                    <Grid item size={{xs:12,md:4}}>
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            animation="wave"
                            height={720}
                            style={{borderRadius:16,marginBottom:10}}
                        />
                    </Grid>
                </Grid>
        </>


    );
};

export default OrgDashSkeleton;
